/**
 * 본사/지사/센터 설정 (/adm/group)
 * ($j.Pages.Admin.Group / body data-page-name="Group")
 *
 * 예전 blade 인라인 스크립트를 로직 그대로 옮겼다. 함수는 모듈 스코프에 두고, 모달이 그리는
 * HTML 의 버튼은 onclick 대신 data-gr="동작" 을 달고 initialize() 의 위임 바인딩이 받는다(CLICK 표).
 * 마크업·스타일은 adm/pages/group.blade.php · sass/admin/pages/_group.scss.
 */

// 본사·지사·센터 전체 트리 — 서버 값은 #page-data (SosokService::getSosok). 검색 인덱스가 모듈을 읽는 즉시 쓴다
const sosok = JSON.parse(document.getElementById('page-data')?.textContent || '{}').sosok || {};

// 현재 선택된 본사/지사 코드
const state = { bonsa: '', gisa: '' };
// 코드 -> 전체 row 데이터 (수정 모달용)
const dataByCode = { bonsa: {}, gisa: {}, center: {} };

// 문자열 해시로 팔레트에서 안정적인 색을 배정
const NAME_PALETTE = [
    '#1565c0', '#00838f', '#6a1b9a', '#ad1457', '#e65100',
    '#558b2f', '#4527a0', '#00695c', '#5d4037', '#283593',
    '#9e9d24', '#0277bd', '#c2185b', '#827717', '#37474f',
];
function hashColor(text) {
    let h = 0;
    const s = String(text);
    for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
    return NAME_PALETTE[h % NAME_PALETTE.length];
}

/* ───────────────── 보드 로딩 ───────────────── */

function fetchList(params) {
    return $.ajax({ url: '/adm/ajax/group/list', type: 'post', data: params });
}

function loadBonsa() {
    return fetchList({ type: 1 }).then(res => renderColumn('bonsa', res.data || [], 1));
}
function loadGisa(bonsaCode) {
    return fetchList({ type: 2, bsanum: bonsaCode }).then(res => renderColumn('gisa', res.data || [], 2));
}
function loadCenter(gisaCode) {
    return fetchList({ type: 3, gsanum: gisaCode }).then(res => renderColumn('center', res.data || [], 3));
}

/**
 * 컬럼 렌더링
 * @param key   bonsa|gisa|center
 * @param rows  목록
 * @param level 1|2|3
 */
function renderColumn(key, rows, level) {
    dataByCode[key] = {};
    rows.forEach(r => { dataByCode[key][r.code] = r; });

    $(`#cnt-${key}`).text(rows.length);

    if (!rows.length) {
        $(`#list-${key}`).html('<div class="gcol-empty">등록된 항목이 없습니다.</div>');
    } else {
        $(`#list-${key}`).html(rows.map(r => renderItem(r, level)).join(''));
    }

    // 현재 필터어 재적용
    applyFilter(key);
}

function renderItem(row, level) {
    const name = row.name || '';
    const color = hashColor(name || row.code);
    const mcnt = $j.Common.Util.int(row.member_count || 0);
    const mcls = mcnt > 0 ? 'gitem-mcount is-link' : 'gitem-mcount';
    const mattr = mcnt > 0 ? ` data-mcount-code="${row.code}" title="클릭하면 회원목록"` : '';
    let meta = `<i class="fas fa-user gitem-uico"></i> <b class="${mcls}"${mattr}>${$j.Common.Util.formatNumber(mcnt)}명</b>`;
    // 지사포인트(g5_group.cash) — 인원수와 같은 그룹이라 누르면 같은 명단이 열린다
    if (level === 2 && row.cash > 0) {
        meta += ` · <span class="gitem-cash is-link" data-mcount-code="${row.code}" title="클릭하면 회원목록">${$j.Common.Util.formatNumber(row.cash)}P</span>`;
    }
    if (level === 1 && row.can_join_code) {
        meta += row.join_code
            ? `<span class="gitem-joincode" data-join-code="${row.join_code}" title="가입코드 — 클릭하면 복사">${row.join_code}<i class="fas fa-copy gitem-copyico"></i></span>`
              + `<button type="button" class="gitem-joincode-issue" data-issue-code="${row.code}" data-reissue="1" title="가입코드 재발급"><i class="fas fa-sync-alt"></i></button>`
            : `<button type="button" class="gitem-joincode-issue" data-issue-code="${row.code}">코드 발급</button>`;
    }

    // 지사 3분대기(settings.fixed_members) 뱃지
    let waitHtml = '';
    if (level === 2 && Array.isArray(row.fixed_members) && row.fixed_members.length) {
        const waits = row.fixed_members
            .map(v => `<span class="badge wait-badge" data-mb-pop="${$j.Common.Util.int(v)}" style="background:${hashColor(v)};color:#fff;cursor:pointer" title="회원 메뉴">${v}</span>`)
            .join('');
        if (waits) waitHtml = `<div class="gitem-wait">${waits}</div>`;
    }

    const arrow = level < 3 ? '<i class="fas fa-chevron-right gitem-arrow"></i>' : '';

    return `
                <div class="gitem" data-code="${row.code}">
                    <span class="gitem-dot" style="background:${color}"></span>
                    <div class="gitem-body">
                        <div class="gitem-line">
                            <div class="gitem-name">${name}</div>
                            <div class="gitem-meta">${meta}</div>
                        </div>
                        ${waitHtml}
                    </div>
                    <button type="button" class="gitem-edit" title="수정"><i class="fas fa-pen"></i></button>
                    ${arrow}
                </div>`;
}

function clearColumn(key, msg) {
    dataByCode[key] = {};
    $(`#cnt-${key}`).text(0);
    $(`#list-${key}`).html(`<div class="gcol-empty">${msg}</div>`);
}

function markActive(key, code) {
    $(`#list-${key} .gitem`).removeClass('active');
    $(`#list-${key} .gitem[data-code="${code}"]`).addClass('active');
}

/** 생성/수정 후 선택상태 유지하며 보드 새로고침 */
function reloadBoard() {
    return loadBonsa().then(() => {
        if (!state.bonsa) return;
        markActive('bonsa', state.bonsa);
        return loadGisa(state.bonsa).then(() => {
            if (!state.gisa) return;
            markActive('gisa', state.gisa);
            return loadCenter(state.gisa);
        });
    });
}

/* ───────────────── 선택/드릴다운 ───────────────── */

// 본사 선택 → 지사 로드 (프로그래매틱 호출용으로 분리, 로드 프로미스 반환)
function selectBonsa(code) {
    code = String(code);
    state.bonsa = code;
    state.gisa = '';
    markActive('bonsa', code);
    $('#add-gisa').prop('disabled', false);
    $('#add-center').prop('disabled', true);
    clearColumn('center', '지사를 선택하세요.');
    return loadGisa(code);
}
// 지사 선택 → 센터 로드
function selectGisa(code) {
    code = String(code);
    state.gisa = code;
    markActive('gisa', code);
    $('#add-center').prop('disabled', false);
    return loadCenter(code);
}

// 인원수 클릭 → 그 그룹 소속 회원목록 모달.
// 보드의 숫자와 같은 조건으로 뽑는다(GroupService::membersByCode) — 어긋나면 보드를 못 믿는다.
let membersTable = null;

function showGroupMembers(key, code, name) {
    const levelName = { bonsa: '본사', gisa: '지사', center: '센터' }[key] || '';
    $.ajax({ url: '/adm/ajax/group/member-list', type: 'get', data: { code } }).then(res => {
        if (!res || !res.ok) return;
        const rows  = res.data || [];
        const total = $j.Common.Util.int(res.total || 0);
        // 본사는 만 단위라 서버가 이름순으로 자른다 — 잘렸으면 그 사실을 말한다
        const cut = total > rows.length
            ? `<div class="text-muted small mb-2">전체 ${$j.Common.Util.formatNumber(total)}명 중 이름순 ${$j.Common.Util.formatNumber(rows.length)}명만 표시합니다. 전체 명단은 기사관리에서 소속으로 검색하세요.</div>`
            : '';
        const html = `<div style="padding:4px 2px;">${cut}`
            + `<table id="group-members-tbl" class="table table-sm table-bordered display" style="width:100%;"></table></div>`;
        $j.Ui.JBModal.html('group-members-modal', html,
            `${levelName} ${name} · ${$j.Common.Util.formatNumber(total)}명`, { width: '680px' });

        if (membersTable) { try { membersTable.destroy(); } catch (err) { /* noop */ } membersTable = null; }
        if (!document.getElementById('group-members-tbl')) return;
        membersTable = new DataTable('#group-members-tbl', {
            data: rows,
            columns: [
                { data: 'mem_name', title: '이름', render: (v, t, r) => $j.F.Admin.Member.Pop.cell(r.mb_no, v) },
                { data: 'mem_driver_type', title: '구분', render: v => v || '-' },
                { data: 'mem_permit', title: '소유/소속', render: v => v || '-' },
                { data: 'mem_car_type', title: '장비', render: v => v || '-' },
                { data: 'sido', title: '지역', render: v => v || '-' },
                { data: 'last_login', title: '최근 로그인', render: v => v || '-' },
            ],
            order: [],          // 서버 정렬(이름순) 유지
            pageLength: 10,
            lengthChange: false,
            searching: true,
            autoWidth: false,
            language: { emptyTable: '없음' },
        });
    });
}

// 3분대기 뱃지 클릭 → 회원 팝오버 (data-mb-pop — 위임은 관리자 부팅이 건다. 항목 선택은 위 핸들러가 .wait-badge 를 비켜간다)

function applyFilter(key) {
    const kw = ($(`.gcol-filter[data-col="${key}"]`).val() || '').toLowerCase();
    $(`#list-${key} .gitem`).each(function () {
        const text = ($(this).find('.gitem-name').text() + ' ' + $(this).find('.gitem-meta').text()).toLowerCase();
        $(this).toggle(text.indexOf(kw) !== -1);
    });
}

/* ───────────────── 통합검색 (본사/지사/센터, 클라이언트) ───────────────── */

const SEARCH_LIMIT = 10;
const LEVEL_LABEL = { 1: '본사', 2: '지사', 3: '센터' };
const escapeHtml = (s) => $j.Common.Util.escapeHtml(s == null ? '' : s);

// sosok(전체 트리)을 평탄화한 검색 인덱스 [{level, code, name, path}]
const searchIndex = (function buildSearchIndex() {
    const idx = [];
    Object.entries(sosok.bonsa || {}).forEach(([code, name]) =>
        idx.push({ level: 1, code, name, path: '' }));
    Object.entries(sosok.gisa || {}).forEach(([code, name]) => {
        const bCode = (sosok.gisa2bonsa || {})[code];
        idx.push({ level: 2, code, name, path: (sosok.bonsa || {})[bCode] || '' });
    });
    Object.entries(sosok.center || {}).forEach(([code, name]) => {
        const bCode = (sosok.center2bonsa || {})[code];
        const gCode = (sosok.center2gisa || {})[code];
        const path = [(sosok.bonsa || {})[bCode], (sosok.gisa || {})[gCode]].filter(Boolean).join(' › ');
        idx.push({ level: 3, code, name, path });
    });
    return idx;
})();

let searchHits = [];   // 현재 표시 중인 결과
let searchActive = -1; // 키보드 하이라이트 인덱스

function escRegExp(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
function highlight(name, kw) {
    const safe = escapeHtml(name);
    if (!kw) return safe;
    return safe.replace(new RegExp('(' + escRegExp(escapeHtml(kw)) + ')', 'gi'), '<mark>$1</mark>');
}

function runSearch(kw) {
    kw = (kw || '').trim();
    if (!kw) { closeSearch(); return; }
    const low = kw.toLowerCase();
    const all = searchIndex.filter(e => e.name && e.name.toLowerCase().indexOf(low) !== -1);
    searchHits = all.slice(0, SEARCH_LIMIT);
    searchActive = -1;
    renderSearchResults(kw, all.length);
}

function renderSearchResults(kw, total) {
    const $box = $('#gSearchResults');
    if (!searchHits.length) {
        $box.html('<div class="gsr-empty">검색 결과가 없습니다.</div>').show();
        return;
    }
    let html = searchHits.map((e, i) => `
                <div class="gsr-item" data-i="${i}" data-level="${e.level}" data-code="${e.code}">
                    <span class="gsr-badge gsr-l${e.level}">${LEVEL_LABEL[e.level]}</span>
                    <span class="gsr-name">${highlight(e.name, kw)}</span>
                    ${e.path ? `<span class="gsr-path">${escapeHtml(e.path)}</span>` : ''}
                </div>`).join('');
    if (total > searchHits.length) {
        html += `<div class="gsr-more">상위 ${searchHits.length}개 표시 · 검색어를 더 입력해 좁혀보세요 (총 ${total}개)</div>`;
    }
    $box.html(html).show();
}

function closeSearch() {
    $('#gSearchResults').hide().empty();
    searchHits = [];
    searchActive = -1;
}

// 결과 선택 → 해당 노드로 드릴다운 + 스크롤
function gotoNode(level, code) {
    level = Number(level);
    code = String(code);
    if (level === 1) {
        selectBonsa(code).then(() => flashItem('bonsa', code));
    } else if (level === 2) {
        const bonsa = (sosok.gisa2bonsa || {})[code];
        if (!bonsa) return;
        selectBonsa(bonsa).then(() => selectGisa(code)).then(() => flashItem('gisa', code));
    } else if (level === 3) {
        const bonsa = (sosok.center2bonsa || {})[code];
        const gisa = (sosok.center2gisa || {})[code];
        if (!bonsa || !gisa) return;
        selectBonsa(bonsa).then(() => selectGisa(gisa)).then(() => {
            markActive('center', code);
            flashItem('center', code);
        });
    }
}

// 대상 항목을 보이게 스크롤하고 잠깐 강조
function flashItem(key, code) {
    const $it = $(`#list-${key} .gitem[data-code="${code}"]`);
    if (!$it.length) return;
    $it[0].scrollIntoView({ block: 'nearest' });
    $it.addClass('gitem-flash');
    setTimeout(() => $it.removeClass('gitem-flash'), 1400);
}

function highlightActive() {
    $('#gSearchResults .gsr-item').removeClass('active');
    if (searchActive >= 0) {
        $(`#gSearchResults .gsr-item[data-i="${searchActive}"]`).addClass('active');
    }
}

/* ───────────────── 등록 진입 ───────────────── */

function addGroup(type) {
    if (type === 2 && !state.bonsa) { $j.Common.Util.swalert('본사를 먼저 선택하세요.'); return; }
    if (type === 3 && !state.gisa) { $j.Common.Util.swalert('지사를 먼저 선택하세요.'); return; }
    showRegisterGroup({}, { type: String(type), bonsa: state.bonsa, gisa: state.gisa });
}

/* ───────────────── 등록/수정 모달 ───────────────── */

/**
 * 등록/수정 모달 열기
 * @param data   수정 시 row 데이터
 * @param preset 신규 등록 시 { type, bonsa, gisa }
 */
function showRegisterGroup(data = {}, preset = null) {
    let bonsa = '';
    let gisa = '';
    let type = '';

    if (data && data.code) {
        const code = data.code;
        if (code.length === 3) {
            bonsa = code;
            type = '1'; // 본사
        } else if (code.length === 6) {
            bonsa = code.substring(0, 3);
            gisa = code;
            type = '2'; // 지사
        } else if (code.length === 9) {
            bonsa = code.substring(0, 3);
            gisa = code.substring(0, 6);
            type = '3'; // 센터
        }
    } else if (preset) {
        type = preset.type;
        bonsa = preset.bonsa || '';
        gisa = preset.gisa || '';
    } else {
        type = '1';
    }

    const isEdit = !!(data && data.code);
    const lockType = isEdit || !!preset; // 컨텍스트가 정해지면 구분 셀렉트 숨김
    const typeLabel = { '1': '본사', '2': '지사', '3': '센터' }[type] || '';
    const title = (isEdit ? typeLabel + ' 수정' : typeLabel + ' 등록');

    const bodyHtml = `
                <form id="registerForm" class="group-form">
                    <div class="form-group" id="typeFormGroup" style="${lockType ? 'display:none' : ''}">
                        <label for="type">구분</label>
                        <select name="type" id="type" class="form-control">
                            <option value="1">본사</option>
                            <option value="2">지사</option>
                            <option value="3">센터</option>
                        </select>
                    </div>
                    <div id="inputArea" style="margin-top:20px;"></div>
                </form>`;

    // 구분별 모달 폭 — 본사는 입력이 적어 좁게, 지사는 2단이라 넓게
    const modalWidth = { '1': '420px', '2': '780px', '3': '620px' }[type] || '520px';
    $j.Ui.JBModal.html('group-modal', bodyHtml, title, {width: modalWidth});

    // 수정 시 소속코드를 타이틀 헤더에 회색으로 표시
    if (data && data.code) {
        $('#group-modal .jb-modal-title').append(
            ` <span style="font-weight:400;color:#9ca3af;font-size:13px;">${data.code}</span>`
            + (data.join_code ? ` <span style="font-weight:400;color:#9ca3af;font-size:13px;">· 가입코드 ${data.join_code}</span>` : '')
        );
    }

    $('#type').val(type);
    renderInputArea(type, bonsa, gisa, data);
}

/**
 * 등록/수정 모달 그리기
 * @param type 1:본사, 2:지사, 3:센터
 * @param bonsa 본사 code
 * @param gisa 지사 code
 * @param data 수정 시 해당 열 데이터
 */
function renderInputArea(type, bonsa='', gisa='',data={}) {
    let html = '';
    const val = (key, def = '') => data[key] || def;
    const isEdit = !!data.code;
    // 상위 소속(본사·지사)은 수정 불가 — 소속코드가 곧 계층(본사3/지사6/센터9 프리픽스)이라
    // 부모를 바꾸면 코드가 바뀌고, 회원 소속·오더·캐시 원장의 sosok 이 전부 어긋난다.
    // 서버(GroupService::update)도 bonsa_code/gisa_code 를 버리므로 화면에서도 잠근다.
    const PARENT_LOCK_HINT = '상위 소속은 변경할 수 없습니다. 옮기려면 새 소속을 등록하고 회원을 옮긴 뒤 이 소속을 삭제하세요.';

    const submitAct = data.code ? 'editSubmit' : 'createSubmit';
    const submitLabel = data.code ? '저장' : '등록';
    // 수정 모드에서만 삭제 버튼 노출 (좌측 정렬)
    const deleteBtn = data.code
        ? `<button type="button" class="btn btn-secondary" style="margin-right:auto" data-gr="deleteSubmit" data-num="${val('num')}"><i class="fas fa-trash-alt"></i> 삭제</button>`
        : '';
    const footer = `
                <div class="gf-footer">
                    ${deleteBtn}
                    <button type="button" class="btn btn-light" data-gr="close">닫기</button>
                    <button type="button" class="btn btn-primary" data-gr="${submitAct}" data-num="${val('num')}">${submitLabel}</button>
                </div>`;

    if (type === '1') {
        html = `
            <div class="form-group">
                <label>본사명</label>
                <input type="text" name="name" class="form-control" placeholder="본사명을 입력하세요" value="${val('name')}">
            </div>
            ${footer}`;
    } else if (type === '2') {
        html = `
       <div class="row">
        <div class="col-md-6 gf-col">
            <div class="gf-section">기본 정보</div>
            <div class="form-group">
                <label>본사명</label>
                <select name="bonsa_code" id="bonsaInForm" class="form-control" ${isEdit ? 'disabled' : ''}>
                    <option value="">본사 선택</option>
                    ${Object.entries(sosok.bonsa).map(([code, name]) =>
                    `<option value="${code}" ${code === bonsa ? 'selected' : ''}>${name}</option>`
                ).join('')}
                </select>
                ${isEdit ? `<div class="gf-hint">${PARENT_LOCK_HINT}</div>` : ''}
            </div>
            <div class="form-group"><label>지사명</label><input type="text" name="name" class="form-control" value="${val('gisa_name')}"></div>
            <div class="form-group">
                <label>지사아이디</label>
                <input type="text" name="id" class="form-control" value="${val('id')}">
                <div class="gf-error" id="idCheckMsg" style="display:none">이미 사용 중인 아이디입니다.</div>
                ${!data.code ? '<div class="gf-hint">비워두면 임시 아이디로 자동 생성됩니다.</div>' : ''}
            </div>
            <div class="form-group">
                <label>비밀번호</label>
                <input type="password" name="pw" class="form-control" placeholder="${data.code ? '변경 시에만 입력' : ''}">
                ${!data.code ? '<div class="gf-hint">비워두면 임시 비밀번호(1234)로 자동 설정됩니다.</div>' : ''}
            </div>
            <div class="form-group"><label>대표번호</label><input type="tel" name="tel" id="gfTel" class="form-control" inputmode="numeric" maxlength="13" placeholder="010-0000-0000" value="${$j.Common.Util.phoneNumber(val('tel'))}"></div>
            <div class="form-group">
                <label>지사포인트</label>
                <div class="gf-point">${Number(val('cash', 0)).toLocaleString()} P</div>
            </div>
        </div>

        <div class="col-md-6 gf-col">
            <div class="gf-section">수수료 설정 (%) <i class="fas fa-question-circle gf-help" data-tip-html="#feeHelpTpl" data-tip-title="수수료율 안내"></i></div>
            <div class="form-group"><label>[수발주자] 수주수수료율</label><input type="text" name="soo_fee_rate" class="form-control" value="${val('soo_fee_rate')}"></div>
            <div class="form-group"><label>[수발주자] 발주수수료율</label><input type="text" name="bal_fee_rate_soo" class="form-control" value="${val('bal_fee_rate_soo')}"></div>
            <div class="form-group"><label>[발주자] 수수료율</label><input type="text" name="bal_fee_rate_bal" class="form-control" value="${val('bal_fee_rate_bal')}"></div>
            <div class="form-group"><label>[업체발주자] 수수료율</label><input type="text" name="bal_fee_rate_company" class="form-control" value="${val('bal_fee_rate_company')}"></div>

            <div class="gf-section">고정 지정자 (3분대기) <i class="fas fa-question-circle gf-help" data-tip-html="#waitHelpTpl" data-tip-title="3분대기 안내"></i></div>
            <div class="form-group">
                <div id="fmWrap" class="fm-wrap"></div>
                <input type="hidden" name="fixed_members" id="fmHidden" value="${(val('fixed_members') || []).join(',')}">
                <div class="fm-add">
                    <input type="text" id="fmSearch" class="form-control" placeholder="회원명 또는 번호 검색" style="display:none; flex:1">
                    <button type="button" class="btn btn-light" id="fmAddBtn" style="white-space:nowrap"><i class="fas fa-plus"></i> 추가</button>
                </div>
                <div class="gf-hint">추가 후 모달 저장 시 적용됩니다.</div>
            </div>
        </div>
    </div>
    ${footer}`;
    } else if (type === '3') {
        html = `
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>본사명</label>
                        <select name="bonsa_code" id="bonsaForCenter" class="form-control" ${isEdit ? 'disabled' : ''}>
                            <option value="">본사 선택</option>
                            ${Object.entries(sosok.bonsa).map(([code, name]) =>
                            `<option value="${code}" ${code === bonsa ? 'selected' : ''}>${name}</option>`
                        ).join('')}
                        </select>
                    </div>
                    <div class="form-group">
                        <label>지사명</label>
                        <select name="gisa_code" id="gisaForCenter" class="form-control" ${isEdit ? 'disabled' : ''}>
                            <option value="">지사 선택</option>
                        </select>
                        ${isEdit ? `<div class="gf-hint">${PARENT_LOCK_HINT}</div>` : ''}
                    </div>
                    <div class="form-group">
                        <label>센터명</label>
                        <input type="text" name="name" class="form-control" value="${val('name')}">
                    </div>
                    <div class="form-group">
                        <label>아이디</label>
                        <input type="text" name="id" class="form-control" value="${val('id')}">
                        <div class="gf-error" id="idCheckMsg" style="display:none">이미 사용 중인 아이디입니다.</div>
                        ${!data.code ? '<div class="gf-hint">비워두면 임시 아이디로 자동 생성됩니다.</div>' : ''}
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>비밀번호</label>
                        <input type="password" name="pw" class="form-control" placeholder="${data.code ? '변경 시에만 입력' : ''}">
                        ${!data.code ? '<div class="gf-hint">비워두면 임시 비밀번호(1234)로 자동 설정됩니다.</div>' : ''}
                    </div>
                    <div class="form-group">
                        <label>전화</label>
                        <input type="tel" name="tel" id="gcTel" class="form-control" inputmode="numeric" maxlength="13" placeholder="010-0000-0000" value="${$j.Common.Util.phoneNumber(val('tel'))}">
                    </div>
                    <div class="form-group">
                        <label>주소</label>
                        <input type="text" name="addr" class="form-control" value="${val('addr')}">
                    </div>
                </div>
            </div>
            ${footer}`;
    }

    $('#inputArea').html(html);
    $('#registerForm').data('excludeNum', val('num') || ''); // 아이디 실시간 중복확인 시 자기 자신 제외용(수정 중)

    // 선택값이 바뀔 때 동작
    if (type === '2') {
        // type 2는 id="bonsaInForm"에 따라 지사 옵션 생성
        fillGisaSelect('bonsaInForm', 'gisaInForm', gisa);
        $j.Common.Form.registerPhoneHandler('gfTel');
        initFixedMembers(val('fixed_members'));
        // 신규 등록일 때만 아이디/비밀번호 추천값을 채운다 — 수정 중인 기존 로그인정보는 건드리지 않는다.
        if (!data.code && bonsa) fillGroupCredentialSuggestion(2, bonsa);
    } else if (type === '3') {
        fillGisaSelect('bonsaForCenter', 'gisaForCenter', gisa);
        $j.Common.Form.registerPhoneHandler('gcTel');
        if (!data.code && gisa) fillGroupCredentialSuggestion(3, gisa);
    }
}

/** 지사/센터 등록 폼의 아이디/비밀번호 칸에 추천값을 채운다(신규 등록 전용). */
function fillGroupCredentialSuggestion(type, parentCode) {
    $.get('/adm/ajax/group/suggest-credentials', { type: type, parent_code: parentCode }, function (res) {
        if (!res) return;
        if (res.id) $('#inputArea [name="id"]').val(res.id);
        if (res.pw) $('#inputArea [name="pw"]').val(res.pw);
    });
}

/* ───────────────── 고정 지정자(3분대기) 뱃지 에디터 ───────────────── */

// 현재 모달의 고정 지정자 목록 [{num, name}]
let fmList = [];

function initFixedMembers(codes) {
    // settings.fixed_members(배열) 또는 CSV 문자열 모두 허용
    const arr = Array.isArray(codes)
        ? codes.map(String)
        : String(codes || '').split(',').map(s => s.trim()).filter(Boolean);
    fmList = arr.map(c => ({ num: c, name: '' }));
    renderFmChips();

    // 이름 조회 (비동기) 후 뱃지 갱신
    if (arr.length) {
        $.get('/adm/ajax/group/members', { nums: arr.join(',') }, function (rows) {
            const map = {};
            (rows || []).forEach(r => { map[String(r.num)] = r.mem_name; });
            fmList.forEach(m => { m.name = map[String(m.num)] || '(탈퇴/없음)'; });
            renderFmChips();
        });
    }

    // 자동완성 추가
    $j.F.Admin.AutoComplete.init({
        id: 'fmSearch', v: '', d: '',
        onSelect: function (id, $li) {
            const num = String($li.data('num'));
            const name = $li.data('name');
            if (!fmList.some(m => String(m.num) === num)) {
                fmList.push({ num: num, name: name });
                renderFmChips();
            }
            $('#fmSearch').val('');
        }
    });

    // 추가 버튼 → 검색창 토글
    $('#fmAddBtn').off('click').on('click', function () {
        const $s = $('#fmSearch');
        $s.toggle();
        if ($s.is(':visible')) $s.val('').trigger('focus');
    });
}

function renderFmChips() {
    if (!fmList.length) {
        $('#fmWrap').html('<span class="fm-empty">지정된 회원이 없습니다.</span>');
    } else {
        $('#fmWrap').html(fmList.map(m =>
            `<span class="fm-chip" data-num="${m.num}">${m.name || ''}<span class="fm-code">#${m.num}</span><span class="fm-x" data-num="${m.num}" title="삭제">&times;</span></span>`
        ).join(''));
    }
    // 최종 적용은 저장 시 → hidden input 값만 동기화
    $('#fmHidden').val(fmList.map(m => m.num).join(','));
}

/**
 * 지사 목록 채우기
 * @param bonsaId 본사 code
 * @param gisaId 지사 code
 * @param selected 선택된 지사 code
 */
function fillGisaSelect(bonsaId, gisaId, selected = '') {
    const bcode = $(`#${bonsaId}`).val();
    const gisaList = Object.entries(sosok.gisa).filter(([code]) => code.startsWith(bcode));

    let options = '<option value="">지사 선택</option>';
    gisaList.forEach(([code, name]) => {
        options += `<option value="${code}" ${code === selected ? 'selected' : ''}>${name}</option>`;
    });

    $(`#${gisaId}`).html(options);
}

/**
 * 등록 / 수정 시 폼 유효성 체크
 * @param type 1:본사, 2:지사, 3:센터
 * @returns {boolean}
 */
function validateForm(type) {
    const name = ($('[name="name"]').val() || '').trim();

    if (!name) {
        $j.Common.Util.swalert('이름을 입력해주세요.');
        $('[name="name"]').focus();
        return false;
    }

    if (name.length < 2) {
        $j.Common.Util.swalert('회사이름을 2자 이상 입력해 주세요.');
        $('[name="name"]').focus();
        return false;
    }

    // 본사는 아이디 입력이 없으므로 이름만 검증
    if (type === '1') return true;

    const id = ($('[name="id"]').val() || '').trim();

    if (!id) {
        $j.Common.Util.swalert('아이디를 입력해주세요.');
        $('[name="id"]').focus();
        return false;
    }

    if (id.length < 2) {
        $j.Common.Util.swalert('아이디를 2자 이상 입력해 주세요.');
        $('[name="id"]').focus();
        return false;
    }

    if (type === '2') {
        const bonsa = $('[name="bonsa_code"]').val();

        if (!bonsa) {
            $j.Common.Util.swalert('본사를 선택해주세요.');
            $('[name="bonsa_code"]').focus();
            return false;
        }
    }

    if (type === '3') {
        const bonsa = $('[name="bonsa_code"]').val();
        const gisa = $('[name="gisa_code"]').val();

        if (!bonsa) {
            $j.Common.Util.swalert('본사를 선택해주세요.');
            $('[name="bonsa_code"]').focus();
            return false;
        }
        if (!gisa) {
            $j.Common.Util.swalert('지사를 선택해주세요.');
            $('[name="gisa_code"]').focus();
            return false;
        }
    }

    return true;
}

/**
 * 등록 버튼 클릭 시
 */
function handleCreateSubmit() {
    const type = $('#type').val();

    if (!validateForm(type)) return;

    const formData = $('#registerForm').serialize();
    $.ajax({
        type: 'POST',
        url: '/adm/ajax/group/create',
        data: formData,
        success: function (res) {
            if (!res || !res.result) { $j.Common.Util.swalert((res && res.msg) || '등록에 실패했습니다.'); return; }
            $j.Common.Util.swalert(res.msg || '등록되었습니다.');
            $j.Ui.JBModal.close('group-modal');
            reloadBoard();
        }
    });
}

/**
 * 수정 후 저장 버튼 클릭 시
 * @param num
 */
function handleEditSubmit(num) {
    let formData = $('#registerForm').serialize();
    formData += `&num=${num}`;
    $.ajax({
        type: 'POST',
        url: '/adm/ajax/group/edit',
        data: formData,
        success: function (res) {
            if (!res || !res.result) { $j.Common.Util.swalert((res && res.msg) || '수정에 실패했습니다.'); return; }
            $j.Common.Util.swalert(res.msg || '수정되었습니다.');
            $j.Ui.JBModal.close('group-modal');
            reloadBoard();
        }
    });
}

/**
 * 삭제 버튼 클릭 시 — 서버에서 하위소속·소속회원 유무를 검사해 없을 때만 삭제
 * @param num g5_group.num
 */
function handleDeleteSubmit(num) {
    $j.Ui.Dialog.open({
        tone:  'danger',
        title: '소속 삭제',
        desc:  '하위 소속과 소속 회원이 모두 없어야 삭제됩니다. 삭제하시겠습니까?',
        confirm: '삭제',
        cancel:  '취소',
    }).then(function (ok) {
        if (!ok) return;
        $.ajax({
            type: 'POST',
            url: '/adm/ajax/group/delete',
            data: { num: num },
            success: function (res) {
                if (!res || !res.result) {
                    $j.Common.Util.swalert((res && res.msg) || '삭제할 수 없습니다.');
                    return;
                }
                // 삭제된 소속이 현재 선택 중이면 선택상태·하위 컬럼 정리
                const code = String(res.code || '');
                if (code && code === state.bonsa) {
                    state.bonsa = ''; state.gisa = '';
                    clearColumn('gisa', '본사를 선택하세요.');
                    clearColumn('center', '지사를 선택하세요.');
                    $('#add-gisa').prop('disabled', true);
                    $('#add-center').prop('disabled', true);
                } else if (code && code === state.gisa) {
                    state.gisa = '';
                    clearColumn('center', '지사를 선택하세요.');
                    $('#add-center').prop('disabled', true);
                }

                $j.Common.Util.swalert('삭제되었습니다.');
                $j.Ui.JBModal.close('group-modal');
                reloadBoard();
            }
        });
    });
}

// ── 모달 버튼의 동작 — data-gr="이름" (+ data-num: 수정·삭제할 소속의 num, 예전 인자 그대로 글자) ──
const CLICK = {
    createSubmit: () => handleCreateSubmit(),
    editSubmit: (el) => handleEditSubmit(el.dataset.num),
    deleteSubmit: (el) => handleDeleteSubmit(el.dataset.num),
    close: () => $j.Ui.JBModal.close('group-modal'),
};

export default class Group {
    initialize() {
        // JS 가 그리는 버튼 — data-gr="동작" 을 위임으로 받는다 (아래 CLICK 표)
        $(document).on('click', '[data-gr]', function (e) {
            const fn = CLICK[this.dataset.gr];
            if (!fn) return;
            if (this.tagName === 'A') e.preventDefault();
            fn(this);
        });

        // blade 마크업에서 옮긴 핸들러 — 열 머리의 [+ 본사/지사/센터]
        $('.btn-add-col[data-level]').on('click', function () { addGroup(Number($(this).data('level'))); });

        // ── 아래는 예전 blade 인라인에서 최상위로 돌던 것 (순서 그대로) ──
        $(function () {
            loadBonsa();
        });

        $(document).on('click', '#list-bonsa .gitem', function (e) {
            if ($(e.target).closest('.gitem-edit, .wait-badge, .gitem-joincode, .gitem-joincode-issue, .gitem-mcount, .gitem-cash').length) return;
            selectBonsa($(this).data('code'));
        });

        // 본사 가입코드 클릭 → 복사
        $(document).on('click', '.gitem-joincode', function (e) {
            e.stopPropagation();
            const code = String($(this).data('joinCode'));
            const done = () => $j.Ui.Toast.show(`가입코드 ${code} 를 복사했습니다`, { type: 'success' });
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(code).then(done, () => window.prompt('가입코드를 복사하세요', code));
            } else {
                window.prompt('가입코드를 복사하세요', code);
            }
        });

        // 본사 가입코드 발급·재발급 — 재발급하면 나눠준 코드가 안 먹으니 한 번 묻는다
        $(document).on('click', '.gitem-joincode-issue', async function (e) {
            e.stopPropagation();
            const $btn = $(this);
            if ($btn.data('reissue') && !await $j.Ui.Dialog.confirm('가입코드를 새로 만들까요?\n업체에 나눠준 지금 코드는 바로 쓸 수 없게 됩니다.')) return;
            $.post('/adm/ajax/group/join-code', { code: String($btn.data('issueCode')) }).then(function (res) {
                if (!res || !res.result) {
                    $j.Common.Util.swalert((res && res.msg) || '발급하지 못했습니다.');
                    return;
                }
                $j.Ui.Toast.show(`가입코드 ${res.join_code} 를 발급했습니다`, { type: 'success' });
                loadBonsa();
            });
        });

        $(document).on('click', '#list-gisa .gitem', function (e) {
            if ($(e.target).closest('.gitem-edit, .wait-badge, .gitem-mcount, .gitem-cash').length) return;
            selectGisa($(this).data('code'));
        });

        // 센터 선택 → 하이라이트만
        $(document).on('click', '#list-center .gitem', function (e) {
            if ($(e.target).closest('.gitem-edit, .wait-badge, .gitem-mcount, .gitem-cash').length) return;
            markActive('center', $(this).data('code'));
        });

        // 수정(펜) 클릭 → 모달
        $(document).on('click', '.gitem-edit', function (e) {
            e.stopPropagation();
            const key = $(this).closest('.gcol').data('col');
            const code = $(this).closest('.gitem').data('code');
            const row = dataByCode[key][code];
            if (row) showRegisterGroup(row);
        });

        $(document).on('click', '.gitem-mcount.is-link, .gitem-cash.is-link', function (e) {
            e.stopPropagation();
            const $item = $(this).closest('.gitem');
            const key   = $item.closest('.gcol').data('col');
            const code  = String($(this).data('mcountCode'));
            const name  = $item.find('.gitem-name').text() || code;
            showGroupMembers(key, code, name);
        });

        // 컬럼별 빠른검색
        $(document).on('input', '.gcol-filter', function () {
            applyFilter($(this).data('col'));
        });

        // 입력 → 검색 (debounce)
        $('#gSearch').on('input', $j.Common.Util.debounce(function () {
            const v = $(this).val();
            $('#gSearchClear').toggle(!!v);
            runSearch(v);
        }, 150));

        // 키보드 네비게이션
        $('#gSearch').on('keydown', function (e) {
            if (!searchHits.length) return;
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                searchActive = Math.min(searchActive + 1, searchHits.length - 1);
                highlightActive();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                searchActive = Math.max(searchActive - 1, 0);
                highlightActive();
            } else if (e.key === 'Enter') {
                e.preventDefault();
                const pick = searchActive >= 0 ? searchHits[searchActive] : searchHits[0];
                if (pick) { gotoNode(pick.level, pick.code); closeSearch(); }
            } else if (e.key === 'Escape') {
                closeSearch();
            }
        });

        // 결과 클릭
        $(document).on('click', '#gSearchResults .gsr-item', function () {
            gotoNode($(this).data('level'), $(this).data('code'));
            closeSearch();
        });

        // 지우기 버튼
        $('#gSearchClear').on('click', function () {
            $('#gSearch').val('').trigger('focus');
            $(this).hide();
            closeSearch();
        });

        // 바깥 클릭 시 결과 닫기
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.gsearch').length) closeSearch();
        });

        // 모달 안 구분 변경
        $(document).on('change', '#type', function () {
            renderInputArea($(this).val());
        });

        // 아이디 입력 중 실시간 중복 확인(지사·센터 공통) — 300ms 디바운스 후 조회, 결과는 입력칸 아래 빨간 문구.
        $(document).on('input', '#registerForm [name="id"]', $j.Common.Util.debounce(function () {
            const $id = $(this);
            const id = $id.val().trim();
            const $msg = $('#idCheckMsg');
            if (!id) { $msg.hide(); return; }

            const excludeNum = $('#registerForm').data('excludeNum') || '';
            $.get('/adm/ajax/group/check-id', { id: id, exclude_num: excludeNum }, function (res) {
                if ($id.val().trim() !== id) return; // 응답 오는 사이 값이 또 바뀌었으면 무시(늦게 도착한 응답 오반영 방지)
                $msg.toggle(!!(res && res.taken));
            });
        }, 300));

        // 모달 안에서 본사 선택 시 → 지사 목록 갱신
        $(document).on('change', '#bonsaForCenter', function () {
            const bonsaCode = $(this).val();
            let options = '<option value="">지사 선택</option>';
            if (bonsaCode) {
                Object.entries(sosok.gisa)
                    .filter(([code]) => code.startsWith(bonsaCode))
                    .forEach(([code, name]) => {
                        options += `<option value="${code}">${name}</option>`;
                    });
            }
            $('#gisaForCenter').html(options);
        });

        // 뱃지 X → 목록에서 제거 (저장 전까지 로컬)
        $(document).on('click', '.fm-x', function (e) {
            e.stopPropagation();
            const num = String($(this).data('num'));
            fmList = fmList.filter(m => String(m.num) !== num);
            renderFmChips();
        });
    }
}
